import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import parse from "html-react-parser";

const ErrorModal = ({ showError, setShowError, errorHeader, errorMessage }) => {
  return (
    <>
      <Modal
        show={showError}
        onHide={() => setShowError(false)}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>{errorHeader}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <center>{parse(errorMessage)}</center>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowError(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ErrorModal;
